export enum FilterStatus {
  ALL = "ALL",
  FINISHED = "FINISHED",
  ACTIVE = "ACTIVE",
}

export type FilterStatusOption = {
  label: string;
  value: FilterStatus;
};
